import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Badge,
  Link,
  Table,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  Chip,
  Skeleton,
} from "@mui/material";
import Grid from "@mui/system/Unstable_Grid/Grid";

/****import styles & icons */
import { detailparcelleStyles } from "../detailparcelle/components/styles";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";

import CloseIcon from "@mui/icons-material/Close";
import { landService } from "../../service/LandService";
import { landService as crmLandService } from "../../service/crm/LandService";
import { noteService } from "../../service/NoteService";
import { contactService } from "../../service/crm/ContactService";
import { useNavigate } from "react-router-dom";
import { useApplication } from "../../hooks/UseApplication";
import { useToast } from "../../Context/ToastContext";
import zipChIcon from "../../assets/Images/logo/zip_logo_whtie_squared.jpg";
import hommageChIcon from "../../assets/Images/logo/hommageCh.png";
import linkedinIcon from "../../assets/Images/logo/linkedin.png";
import jwtInterceptor from "../../service/jwtInterceptor";
import { API_URL } from "../../utils/constants";
import CustomBtn from "../customBtns/CustomBtn";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import StarOutlined from "@mui/icons-material/StarOutlined";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { ChangeFavoriteDialog } from "../FavoriteBox";
import CreateContact from "../detailcrm/modals/creationcontact";
import Modal from "@mui/material/Modal";
import { LAND_ENDPOINTS } from "../../utils/api";
import CreateNoteDynamic from "../CreateNoteDynamic";
import { landsLinkService } from "../../service/LandsLinkService";

import Note from "../detailcrm/note/note";
import proj4 from "proj4";
import { NotesResumeParcelle } from "./NotesResumeParcelle";
import { useFavorites } from "../../Context/FavoriteContext";
import {AttachedLandsTagList} from "./AttachedLandsTagList";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import {AttachTagModal} from "../tags/AttachTagModal";
import {landsInteractionsService} from "../../service/crm/LandsInteractionsService";

/**** style ****/
const brown = "#363636";
const paddingInlineNone = {
  paddingInline: "0px",
};

const contactTdStyle = {
  maxWidth: "200px",
  paddingRight: "10px!important",
};

const ParcelResume = (props) => {
  const { closeFenetre, landId } = props;
  const [detailParcelle, setDetailParcelle] = useState({});
  const [modifiedGeoPortaLink, setModifiedGeoPortaLink] = useState("");
  const { details, setDetails } = useApplication();
  const [openFavoriteDialog, setOpenFavoriteDialog] = useState(false);
  const [isLandsLoading, setIsLandsLoading] = useState(true);
  const [isFaosLoading, setIsFaosLoading] = useState(true);
  const [isTransactionsLoading, setIsTransactionsLoading] = useState(true);
  const [isContactsLoading, setIsContactsLoading] = useState(true);
  const [isNotesLoading, setIsNotesLoading] = useState(true);
  const [isManageLoading, setIsManageLoading] = useState(true);
  const [isSolarPotentialLoading, setIsSolarPotentialLoading] = useState(true);
  const navigate = useNavigate();
  const [notes, setNotes] = useState([]);
  const [crmLandId, setCrmLandId] = useState(null);
  const [contactsList, setContactsList] = useState([]);
  const [nbrTransactions, setNbrTransactions] = useState(0);
  const [nbrEnquetes, setNbrEnquetes] = useState(0);
  const [solarPotentialUrl, setSolarPotentialUrl] = useState("");
  const [openCreateContact, setOpenCreateContact] = useState(false);
  const [changeOnChild, setChangeOnChild] = useState(false);
  const [createNoteOpen, setCreateNoteOpen] = useState(false);
  const { getFavoriteStatus, updateFavorite } = useFavorites();
  const [showTagSelectModal, setShowTagSelectModal] = useState(false);
  const [avalaibleTags, setAvalaibleTags] = useState([])
  const [selectedLands, setSelectedLands] = useState([])

  const wgs84 = "EPSG:4326";
  const lv95 = "EPSG:2056";

  const toaster = useToast();

  const handleOnClickDetails = () => {
    window.open(`/details/${detailParcelle.land_id}`, "_blank");
  };

  useEffect(() => {
    if (landId) {
      fetchDetails()
        .then((response) => console.log("finished fetchDetails()"))
        .catch((error) => toaster.notifyError(error.message));
    }
  }, [landId]);

  async function fetchAllContacts(landsSource) {
    setIsContactsLoading(true);

    const newElasticContact = await addElasticContactToContactList(landsSource);
    const newCRMContact = await fetchContacts(landsSource.land_id);
    const newCOntactList = newElasticContact.concat(newCRMContact);
    setContactsList(newCOntactList);

    setIsContactsLoading(false);
  }

  async function fetchDetails() {
    setIsLandsLoading(true);
    const detailById = await landService
      .findLandById(landId)
      .catch((error) => toaster.notifyError(error.message))
      .finally(() => setIsLandsLoading(false));

    if (!detailById) {
      throw new Error("impossible de trouver la parcelle");
    }

    if (detailById._source.landsInteractions?.isFavorites) {
      updateFavorite(landId, true);
    }

    setDetails(detailById._source);
    setDetailParcelle(detailById._source);
    setSelectedLands([detailById._source.land_id]);

    fetchAllContacts(detailById._source).then(() =>
      console.log("all contact fetched")
    );

    console.log(
      "detailById._source.landsLink?.ensoleillementLink",
      detailById._source.landsLink?.ensoleillementLink
    );
    if (!detailById._source.landsLink?.ensoleillementLink) {
      fetchSolarPotential(detailById)
        .then((response) => {
          console.log("fetch solarPotential done");
        })
        .catch((error) => toaster.notifyError(error.message));
    } else
      setSolarPotentialUrl(detailById._source.landsLink.ensoleillementLink);

    if (
      detailById._source.geo_portal_link &&
      detailById._source.center.lon !=null &&
      detailById._source.center.lat != null
    ) {
      const parcelle = '&locparcelle=' + detailById._source.no_parcelle;
      const adresseId = '&locadresse=' + detailById._source.address_id;
      const centerMark = '&keepgraphic=true&addcrosshair=true';

      const [tempMn95X, tempMn95Y] = proj4(wgs84, lv95, [
        detailById._source.center.lon,
        detailById._source.center.lat,
      ]);

      setModifiedGeoPortaLink(
        detailById._source.geo_portal_link
          .replace("mapresources=AMENAGEMENT", "mapresources=AMENAGEMENT,CADASTRE")
          .replace("scale=750", "scale=500")
          .replace("{x}", Math.round(tempMn95X))
          .replace("{y}", Math.round(tempMn95Y)) + parcelle + adresseId + centerMark
      );
    }

    if (!detailById || !detailById._source || !detailById._source.old_lands_id) {
      console.warn("Impossible de récupérer old_lands_id", detailById);
      return;
    }

    const oldLandId = detailById._source.old_lands_id;

    await fetchNotes(detailById._source.land_id);
    await fetchTransactions(oldLandId);
    await fetchEnquetes(oldLandId);

    setIsManageLoading(true);
    crmLandService
      .isManaged(detailById._source.land_id)
      .then((response) => {
        setCrmLandId(response);
      })
      .finally(() => setIsManageLoading(false));
  }

  async function fetchNotes(landId) {
    setIsNotesLoading(true);
    const notesData = await noteService.findNoteByLandId(landId);
    setIsNotesLoading(false);
    setNotes(notesData);
  }

  const fetchContacts = async (externalLandId) => {
    const contacts = await contactService.findByExternalLandId(externalLandId);

    return contacts.map((contact) => {
      return {
        name: contact.lastName + " " + contact.firstName,
        type: contact.types,
        byCRM: true,
        link: "/detail/:id/:contactId"
          .replace(":id", contact.lands[0]._id)
          .replace(":contactId", contact._id),
      };
    });
  };

  const handleCloseFavoriteModal = (e) => {
    fetchDetails();
    setOpenFavoriteDialog(false);
  };

  const manageLand = async () => {
    setIsManageLoading(true);
    const manageErrorMessage =
      "Erreur durant la gestion de la parcelle : :errorMessage";
    try {
      const response = await jwtInterceptor.post(
        LAND_ENDPOINTS.manage.replace(":landId", detailParcelle.land_id)
      );
      if (response.status.toString().startsWith("2")) {
        toaster.notifySuccess("Succès : Vous pouvez la consulter dans le CRM.");
        setCrmLandId(1); // Mettre à jour l'état pour changer le bouton
      } else {
        toaster.notifyError(
          manageErrorMessage.replace(":errorMessage", response.data.message)
        );
      }
      fetchDetails();
    } catch (error) {
      toaster.notifyError(
        manageErrorMessage.replace(":errorMessage", error.message)
      );
    } finally {
      setIsManageLoading(false);
    }
  };

  const handleCloseCreateContact = () => {
    setOpenCreateContact(false);
  };
  const handleOpenCreateContact = () => {
    setOpenCreateContact(true);
  };

  const handleContactCreated = async (newContact) => {
    await fetchAllContacts(details);
    const landId = details.land_id;
    const contactId = newContact._id;

    if(!contactId){
      console.warn("Contact crée sans Id , redirection impossible");
      return;
    }
    navigate(`/detail/${landId}/${contactId}`);
  };

  const fetchSolarPotential = async (landWithSource) => {
    const landSource = landWithSource._source;
    setIsSolarPotentialLoading(true);

    const foundedSolarPotentialUrl =
      await landsLinkService.getEnsoleillementLinkByLand(landSource);
    setSolarPotentialUrl(foundedSolarPotentialUrl);

    setIsSolarPotentialLoading(false);

    let newLandsLinks;
    if (landSource.landsLinks) {
      newLandsLinks = { ...landSource.landsLinks };
    } else newLandsLinks = { land_id: landSource.land_id };

    newLandsLinks.ensoleillementLink = foundedSolarPotentialUrl;
    landsLinkService.saveLandsLink(newLandsLinks).then((newLandsLinks) => {
      setDetails({ ...details, landsLinks: newLandsLinks });
    });
  };

  async function addElasticContactToContactList(rowWithoutSource) {
    let newContactsList = [];

    if (rowWithoutSource.owners && rowWithoutSource.owners.length > 0) {
      newContactsList = rowWithoutSource.owners.map((owner) => {
        return {
          name: owner.name,
          type: owner.type === "private" ? "privé" : "-",
          byCRM: false,
          link: "#",
        };
      });
    }

    return newContactsList;
  }

  const formatSearchUrl = (baseUrl, query) => {
    return `${baseUrl}${encodeURIComponent(query)}`;
  };

  const fetchTransactions = async (oldLandId) => {
    setIsTransactionsLoading(true);
    try {
      const response = await jwtInterceptor.get(`${API_URL}/transaction/land/${oldLandId}`, {
        params: { size: 2000, page: 1, region: "all" },
      });
      const data = response.data?.data || [];
      setNbrTransactions(data.length);
    } catch (err) {
      console.error(err);
    } finally {
      setIsTransactionsLoading(false);
    }
  };

  const fetchEnquetes = async (oldLandId) => {
    if (!oldLandId) {
      console.warn("fetchEnquetes appelé avec oldLandId undefined");
      setIsFaosLoading(false);
      return;
    }

    setIsFaosLoading(true);
    try {
      const response = await jwtInterceptor.get(`${API_URL}/faos/land/${oldLandId}`, {
        params: { size: 2000, page: 1, region: "all" },
      });

      const data = response.data?.data || [];

      setNbrEnquetes(data.length);
    } catch (err) {
      console.error("Erreur fetchEnquetes :", err);
    } finally {
      setIsFaosLoading(false);
    }
  };

  const getStarIcon = () => {
    return getFavoriteStatus(landId) ? (
      <StarOutlined sx={{ fill: "#363636", height: "17px" }} />
    ) : (
      <StarBorderIcon sx={{ fill: "#fff", height: "17px" }} />
    );
  };

  const onClickTagButton = () => {
    setShowTagSelectModal(true)
  }

  const addTagsToSelection = (tags) => {
    landsInteractionsService.attachTags(tags, selectedLands).then(updated => {
      if(updated) {
        fetchDetails();

        setSelectedLands([]);
        setShowTagSelectModal(false);

        toaster.notifySuccess("Tags ajouté avec succès");
      }
    }).catch(error => {
      toaster.notifyError("Erreur lors de l'ajout des tags");
    });
  }

  const btnMobileStyles = {
    flexDirection: {
      xs: "coumns",
    },
    alignItems: {
      xs: "flex-start",
    },
    gap: {
      xs: "14px",
    },
  };

  return (
    <Paper className="inner p-3">
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            flexWrap: "wrap ",
          }}
        >
          <Box
            sx={{
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              display: "flex",
            }}
          >
            <CloseIcon
              onClick={closeFenetre}
              sx={{ cursor: "pointer", display: "block" }}
            />
            <Typography sx={{ color: "brown" }}>
              <span style={{ fontWeight: "bold" }}>
                {details?.landsInteractions?.isArchived ? "Archivée" : ""}
              </span>
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              marginBottom: "8px",
            }}
          >
            <Box onClick={handleOnClickDetails} sx={{ cursor: "pointer" }}>
              {isLandsLoading ? (
                <Skeleton variant="rounded" animation="wave" width="300px" />
              ) : (
                <Typography
                  variant="h4"
                  className=""
                  sx={{
                    ...detailparcelleStyles.fontWeightTitle,
                    mr: 1,
                    fontSize: "1.625rem",
                    textDecoration: "underline",
                    color: "#000000",
                  }}
                >
                  Parcelle n°{detailParcelle.no_parcelle}
                </Typography>
              )}
            </Box>
            <Box sx={{ minWidth: "100px" }}>
              <Box className="d-flex  justify-content-evenly">
                {isFaosLoading ? (
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    className="px-4"
                  />
                ) : (
                  <Badge
                      sx={{
                        "& .MuiBadge-badge": {
                          background: "#CEDEF2",
                          color: "#0D0D0D",
                        }
                      }}
                    class="px-4"
                    badgeContent={
                      nbrEnquetes > 0 ? nbrEnquetes.toString() : "0"
                    }
                    size="small"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <BiotechOutlinedIcon style={{ color: brown }} />
                  </Badge>
                )}

                {isTransactionsLoading ? (
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    className="px-4"
                  />
                ) : (
                  <Badge
                    class="px-4"
                    sx={{
                      "& .MuiBadge-badge": {
                        background: "#CEDEF2",
                        color: "#0D0D0D",
                      }
                    }}
                    badgeContent={
                      nbrTransactions > 0 ? nbrTransactions.toString() : "0"
                    }
                    color="primary"
                    size="small"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <MonetizationOnOutlinedIcon style={{ color: brown }} />
                  </Badge>
                )}
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexWrap: {
                xl: "nowrap",
                lg: "nowrap",
                md: "nowrap",
                sm: "wrap",
                xs: "wrap",
              },
              ...btnMobileStyles,
            }}
          >
            {isLandsLoading ? (
              <Skeleton variant="rounded" animation="wave" width="100%" />
            ) : (
                <>
                <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: 1,
                      flexWrap: 'wrap'
                    }}
                >
                  <CustomBtn
                      label="Tagger"
                      bgColor={'#1B208C'}
                      iconBg={'#1B208C'}
                      customBgHover={'#363636'}
                      styles={"7px"}
                      icon={<LabelImportantIcon />}
                      click={onClickTagButton}
                  />

                  <CustomBtn
                      bgColor={getFavoriteStatus(landId) ? "#FFC107" : "#363636"}
                      label="Favoris"
                      iconBg={getFavoriteStatus(landId) ? "#FFC107" : "#363636"}
                      icon={getStarIcon()}
                      textColor={getFavoriteStatus(landId) ? "#363636" : "#fff"}
                      click={() => setOpenFavoriteDialog(true)}
                  />

                  <CustomBtn
                      click={() => setCreateNoteOpen(true)}
                      bgColor={'#1B208C'}
                      iconBg={'#1B208C'}
                      label="Note"
                      icon={"+"}
                  />

                {isManageLoading ? (
                    <Box sx={{ minWidth: '100px' }}>
                      <Skeleton variant="rectangular" height={36} animation="wave" sx={{ borderRadius: '4px' }} />
                    </Box>
                ) : (
                    <CustomBtn
                        bgColor={'#1B208C'}
                        iconBg={'#1B208C'}
                        label={crmLandId === 0 ? "Gérer" : "Contact"}
                        icon={"+"}
                        click={crmLandId === 0 ? manageLand : handleOpenCreateContact}
                    />
                )}
                </Box>
                </>
            )}
          </Box>
        </Box>
        <Box sx={{ mb: 3 }}>
          {isLandsLoading ? (
            <Skeleton
              variant="rounded"
              animation="wave"
              className="p-3"
              height="300px"
            />
          ) : (
            <Box className="p-3" sx={detailparcelleStyles.grayBg}>
              {detailParcelle.canton && (
                <p>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Canton :
                  </span>{" "}
                  {detailParcelle.canton}
                </p>
              )}

              {detailParcelle.address_full && (
                <p>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Adresse :
                  </span>{" "}
                  {detailParcelle.address_full}
                </p>
              )}
              {detailParcelle.average_building_year && (
                <p>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Année de construction :
                  </span>{" "}
                  {detailParcelle.average_building_year}
                </p>
              )}
              {detailParcelle.surface && (
                <p>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Surface parcelle :
                  </span>{" "}
                  {detailParcelle.surface} m<sup>2</sup>
                </p>
              )}
              {detailParcelle.zone && (
                <p style={{ mb: 0 }}>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Zone d'affectation :
                  </span>{" "}
                  {detailParcelle.zone}
                </p>
              )}
            </Box>
          )}
        </Box>
        <Grid container columnSpacing={1} rowSpacing={1} sx={{ mb: 3 }}>
          <Grid lg={6}>
            {isLandsLoading ? (
              <Skeleton variant="rounded" animation="wave" width="100px" />
            ) : (
              <Link
                href={detailParcelle.rf_uri}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: "flex", justifyContent: "flex-start" }}
              >
                <CustomBtn
                  bgColor={"#D9C4B8"}
                  label="Registre Foncier"
                  iconBg={"#D9C4B8"}
                  icon={<OpenInNewIcon sx={{ fontSize: "18px", color:"#000000" }} />}
                  // fontSizes="12px"
                  textColor={'#000000'}
                  noShadow
                  fullWidth
                  style={{
                    transition: 'background-color 0.4s ease, color 0.4s ease',
                    '&:hover': {
                      backgroundColor: '#000000 !important',
                      color: '#ffffff !important',
                    },
                    '&:hover .MuiChip-label': {
                      color: '#ffffff',
                    },
                    '&:hover .MuiAvatar-root': {
                      backgroundColor: '#000000 !important',
                    },
                    '&:hover svg': {
                      color: '#ffffff !important',
                    }
                  }}
                />
              </Link>
            )}
          </Grid>
          <Grid lg={6}>
            {isLandsLoading ? (
              <Skeleton variant="rounded" animation="wave" width="100px" />
            ) : (
              <Link
                href={modifiedGeoPortaLink}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: "flex", justifyContent: "flex-start" }}
              >
                <CustomBtn
                  bgColor={"#D9C4B8"}
                  label="Géoportail"
                  iconBg={"#D9C4B8"}
                  icon={<OpenInNewIcon sx={{ fontSize: "18px", color:"#000000"  }} />}
                  // fontSizes="12px"
                  noShadow
                  textColor={'#000000'}
                  fullWidth
                  style={{
                    transition: 'background-color 0.4s ease, color 0.4s ease',
                    '&:hover': {
                      backgroundColor: '#000000 !important',
                      color: '#ffffff !important',
                    },
                    '&:hover .MuiChip-label': {
                      color: '#ffffff',
                    },
                    '&:hover .MuiAvatar-root': {
                      backgroundColor: '#000000 !important',
                    },
                    '&:hover svg': {
                      color: '#ffffff !important',
                    }
                  }}
                />
              </Link>
            )}
          </Grid>

          <Grid lg={6}>
            {isLandsLoading ? (
              <Skeleton variant="rounded" animation="wave" width="100px" />
            ) : (
              <Link
                href={detailParcelle.cadastreLink}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: "flex", justifyContent: "flex-start" }}
              >
                <CustomBtn
                  bgColor={"#D9C4B8"}
                  label="Cadastre"
                  iconBg={"#D9C4B8"}
                  textColor={'#000000'}
                  icon={<OpenInNewIcon sx={{ fontSize: "18px", color:"#000000" }} />}
                  // fontSizes="12px"
                  noShadow
                  fullWidth
                  style={{
                    transition: 'background-color 0.4s ease, color 0.4s ease',
                    '&:hover': {
                      backgroundColor: '#000000 !important',
                      color: '#ffffff !important',
                    },
                    '&:hover .MuiChip-label': {
                      color: '#ffffff',
                    },
                    '&:hover .MuiAvatar-root': {
                      backgroundColor: '#000000 !important',
                    },
                    '&:hover svg': {
                      color: '#ffffff !important',
                    }
                  }}
                />
              </Link>
            )}
          </Grid>

          {isLandsLoading && isSolarPotentialLoading ? (
            <Skeleton animation="wave" variant="text">
              <Grid lg={6}></Grid>
            </Skeleton>
          ) : !solarPotentialUrl ? (
            <></>
          ) : (
            <Grid lg={6}>
              <Link
                href={solarPotentialUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: "flex", justifyContent: "flex-start" }}
              >
                <CustomBtn
                    bgColor={"#D9C4B8"}
                    textColor={"#000000"}
                    label="Ensoleillement"
                    iconBg={"#D9C4B8"}
                    icon={<OpenInNewIcon sx={{ fontSize: "18px", color: "#000000", transition: 'color 0.4s ease' }} />}
                    noShadow
                    fullWidth
                    style={{
                      transition: 'background-color 0.4s ease, color 0.4s ease',
                      '&:hover': {
                        backgroundColor: '#000000 !important',
                        color: '#ffffff !important',
                      },
                      '&:hover .MuiChip-label': {
                        color: '#ffffff',
                      },
                      '&:hover .MuiAvatar-root': {
                        backgroundColor: '#000000 !important',
                      },
                      '&:hover svg': {
                        color: '#ffffff !important',
                      }
                    }}
                />
              </Link>
            </Grid>
          )}
        </Grid>
        <Box>
          <Box className="d-flex justify-content-between align-items-center">
            <Typography
                variant="h5"
                component="h5"
                style={detailparcelleStyles.fontWeightTitle}
            >
              {isLandsLoading ? <Skeleton /> : "Tags"}
            </Typography>
          </Box>
          <Box className="overflow-auto" sx={{ maxHeight: "350.27px", mb: 3 }} >
            {isContactsLoading ? (
                <Skeleton
                    variant="rounded"
                    animation="wave"
                    height="100%"
                    width="100%"
                />
            ) : (
                <AttachedLandsTagList
                    land={detailParcelle}
                />
            )}
          </Box>
          <Box className="d-flex justify-content-between align-items-center">
            <Typography
              variant="h5"
              component="h5"
              style={detailparcelleStyles.fontWeightTitle}
            >
              {isContactsLoading ? <Skeleton /> : "Contacts"}
            </Typography>
          </Box>
          <Box className="overflow-auto" sx={{ maxHeight: "350.27px", mb: 3 }} >
            {isContactsLoading ? (
              <Skeleton
                variant="rounded"
                animation="wave"
                height="100%"
                width="100%"
              />
            ) : (
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ ...contactTdStyle, ...paddingInlineNone }}>
                      Nom
                    </TableCell>
                    <TableCell sx={paddingInlineNone}>Type</TableCell>
                    <TableCell sx={paddingInlineNone}>Rechercher</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody style={{ overflow: "auto" }}>
                  {contactsList && contactsList.length > 0 ? (
                    contactsList.map((item) => {
                      const query = item.name || item.crm;
                      const searchChUrl = formatSearchUrl(
                        "https://search.ch/?q=",
                        query
                      );
                      const zipChUrl = formatSearchUrl(
                        "https://zip.ch/fr/results/?q=",
                        query
                      );
                      const linkedInUrl = formatSearchUrl(
                        "https://www.linkedin.com/search/results/all/?keywords=",
                        query
                      );
                      const hommageUrl = formatSearchUrl(
                        "https://www.hommages.ch/fr/avis-de-deces?name=",
                        query
                      );

                      return (
                        <TableRow
                          key={item.name}
                          onClick={() => navigate(item.link)}
                          sx={
                            item.byCRM
                              ? { cursor: "pointer" }
                              : { cursor: "inherit" }
                          }
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{ ...contactTdStyle, ...paddingInlineNone }}
                          >
                            {item.name}{" "}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={paddingInlineNone}
                          >
                            {item.type}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={paddingInlineNone}
                          >
                            {item.byCRM ? (
                              <>
                                <Chip sx={{ height: "20px" }} label="CRM" />
                              </>
                            ) : (
                              <>
                                <a
                                  href={searchChUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    height="20"
                                    alt="search.ch"
                                    src="https://lib.search.ch/favicon.ico?c=3"
                                  />
                                </a>
                                <a
                                  href={zipChUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginInline: "5px" }}
                                >
                                  <img
                                    height="20"
                                    alt="zip.ch"
                                    src={zipChIcon}
                                    style={{ objectFit: "contain" }}
                                  />
                                </a>
                                <a
                                  href={hommageUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginInline: "5px" }}
                                >
                                  <img
                                    height="20"
                                    alt="hommage.ch"
                                    src={hommageChIcon}
                                    style={{ objectFit: "contain" }}
                                  />
                                </a>
                                <a
                                  href={linkedInUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    height="21"
                                    alt="linkedin"
                                    src={linkedinIcon}
                                    style={{ objectFit: "contain" }}
                                  />
                                </a>
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4}>Aucun contact trouvé</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            )}
          </Box>
          <Box className="d-flex justify-content-between align-items-center">
            <Typography
              variant="h5"
              component="h5"
              style={detailparcelleStyles.fontWeightTitle}
            >
              {isNotesLoading ? <Skeleton /> : "Notes"}
            </Typography>
          </Box>
          <Box className="overflow-auto" sx={{ maxHeight: "350.27px" }}>
            {isNotesLoading ? (
              <Skeleton
                variant="rounded"
                animation="wave"
                height="100px"
                width="100%"
              />
            ) : (
              <>
                <NotesResumeParcelle
                  notes={notes}
                  onNotesChanges={() => fetchNotes(details.land_id)}
                />
              </>
            )}
          </Box>
        </Box>
      </>
      <ChangeFavoriteDialog
        row={detailParcelle}
        open={openFavoriteDialog}
        onClose={(e) => handleCloseFavoriteModal(e)}
      ></ChangeFavoriteDialog>
      <Modal
        open={openCreateContact}
        onClose={handleCloseCreateContact}
        aria-labelledby="creation-note-title"
        aria-describedby="creation-note-description"
        style={{ zIndex: "99999" }}
      >
        <CreateContact
          closeIt={handleCloseCreateContact}
          numParcelle={crmLandId}
          onContactCreated={handleContactCreated}
        />
      </Modal>
      <Modal open={createNoteOpen}>
        <CreateNoteDynamic
          ownerType="land"
          ownerId={detailParcelle.land_id}
          closeIt={async () => {
            setCreateNoteOpen(false);
            await fetchNotes(detailParcelle.land_id);
          }}
        />
      </Modal>
      <AttachTagModal
          open={showTagSelectModal}
          onClose={() => setShowTagSelectModal(false)}
          onValidateTags={(event) => addTagsToSelection(event)}
      ></AttachTagModal>
    </Paper>
  );
};

export default ParcelResume;
